<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/SA/SA.jpg" alt="软件算法">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">Software & Algorithms</div>
                <div class="detail-banner-desc">
                    Self-developed audio tuning system software, compatible with various DSP and SOC chips (ADI, Qualcomm, etc.);<br />
                    Rich algorithm portfolio ranging from basic to advanced levels to meet diverse acoustic requirements;<br />
                    Capable of cross-platform algorithm porting;<br />
                    It features wide coverage, evolvability, high reliability & stability.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Virtual Surround Technology</div>
                    <div class="detail-desc">
                        <div>
                            Amor Aural & TruLogic Virtual Surround Technology converts a two-channel stereo signal into a multi-channel surround sound signal, so you can immerse yourself in a surround listening experience.
                        </div>
                    </div>
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/SA/xnhr.jpg" alt="虚拟环绕技术">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Features
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Immersive Surround Sound Experience</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Noise Reduction</div>
                    <div class="detail-desc">
                        <div>
                            The engine and road noises generated while driving can often affect your in-car experience. AmorAccoustic Noise Reduction Technology monitors and actively removes these unwanted sounds from the cabin in real time, so you can get a refined and more comfortable experience.
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Features
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">The Whole World Turns Quiet</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/SA/jz.jpg" alt="降噪">
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">IESE Sound Simulation</div>
                    <div class="detail-desc">
                        <div>
                            iESE Technology allows an electric vehicle user to get an immersive and dynamic engine sound experience, creating a stronger connection and heightened engagement between the driver and the vehicle.
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/SA/IESE.jpg" alt="IESE 声浪模拟">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Features
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Exhilarating Engine Sounds for You</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'Software & Algorithms - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics/SA.html'
};

import { createApp } from 'vue';
import App from './SA.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./SA.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
